import { takeLatest, call, put } from 'redux-saga/effects';
import * as api from '../../../server';
import { message } from 'antd';
import * as Type from "../../actions/actionTypes";
import {getBatchMember} from "../../../server";
// import {uploadEvidence} from "../Meeting";
message.config({
    duration: 2,
    maxCount: 1,
});
export function* getMember(action) {
    try {
        const { path } = action;
        const pathName=path.substring(path.lastIndexOf("/")+1);
        if(pathName=='pendingCloseDivision'||pathName=='lcPendingMediationDivision'){
            const memberList = yield call(api.getBatchMember, path)
            yield put({ type: Type.SET_MEMBER, memberList, path })
        }else{
            const memberList = yield call(api.getMember, path)
            yield put({ type: Type.SET_MEMBER, memberList, path })
        }
        // yield put({ type: Type.SET_MEMBER, memberList, path })
    } catch (error) {
        message.error(error)
    }
}
export function* getMemberRequest() {
    yield takeLatest(Type.GET_MEMBER, getMember)
}

// export function* postNormal(action) {
//     try {
//         const { path, systemNum, endUrl, cb = window.noop } = action;
//         const res = yield call(api.postNormal, path, systemNum, endUrl)
//         if(res && res.status === 0){
//             yield call(cb)
//         }
//     } catch (error) {
//         message.error(error)
//     }
// }
// export function* postNormalRequest() {
//     yield takeLatest(Type.POST_NORMAL, postNormal)
// }
export function* findClosedReason(action) {
    try {
        const { path } = action;
        const res = yield call(api.findClosedReason, path)
        yield put({
           type: Type.SET_CLOSED_REASON,
           data: res,
        })
    } catch (error) {
        message.error(error)
    }
}
export function* findClosedReasonRequest() {
    yield takeLatest(Type.GET_CLOSED_REASON, findClosedReason)
}
// // 导入送达回执
// export function* getHandleUpload(action) {
//     try {
//         const { path, name, file, cb = window.noop } = action;
//         const res = yield call(api.getHandleUpload, path, name, file)
//         if(res && res.status === 0){
//             yield put({ type: 'HIDE_LOADING' })
//             // 后端偷懒返回体不统一
//             yield call(cb, res.msg)
//         } else {
//             message.error(res && res.msg)
//             yield put({ type: 'HIDE_LOADING' })
//         }
//     } catch (error) {
//         message.error(error)
//     }
// }
// export function* getHandleUploadRequest() {
//     yield takeLatest(Type.GET_HANDLE_UPLOAD, getHandleUpload)
// }
//
// // 获取文书列表
// export function* findDocList(action) {
//     try {
//         const { path, operation, status, isLitigationGuarantee = 0 } = action;
//         const doclist = yield call(api.findDocList, path, operation, status, isLitigationGuarantee);
//         yield put({
//             type: Type.SET_DOC_LIST,
//             doclist,
//             operation,
//         })
//
//     } catch (error) {
//         message.error(error)
//     }
// }
// export function* findDocListRequest() {
//     yield takeLatest(Type.GET_DOC_LIST, findDocList)
// }
//
// // 获取token拨打电话
// export function* getCallToken(action) {
//     try {
//         const { deviceId, cb } = action;
//         const res = yield call(api.getCallToken, deviceId);
//         if(res) {
//             yield put({ type: 'HIDE_LOADING' })
//             console.log(111111,res)
//             yield call(cb, res.accountId, res.token)
//         }
//
//     } catch (error) {
//         message.error(error)
//     }
// }
// export function* getCallTokenRequest() {
//     yield takeLatest(Type.GET_CALL_TOKEN, getCallToken)
// }
